import { useTranslation } from 'react-i18next';

import djangoContextHelper from 'src/utils/django-context-helper';
import Icons from 'src/components/Icons';
import signOut from 'src/utils/users/logout';

import styles from './Footer.module.scss';

const Footer = () => {
  const { user } = djangoContextHelper();
  const { t } = useTranslation('footer');
  return (
    <footer className={styles.footer}>
      <div className={styles.logo}>
        Moving
        <br />
        Studio
        <div className={styles.info}>
          <div>好有感企業社</div>
          <div>93146661</div>
          <div>Tel: 0983721919</div>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.title}>{t('account')}</div>
          {user ? (
            <a className={styles.item} href="/user">
              {t('my-page')}
            </a>
          ) : (
            <a className={styles.item} href="/user/sign-up">
              {t('register')}
            </a>
          )}
          {user ? (
            <button className={styles.item} onClick={() => signOut()}>
              {t('sign-out')}
            </button>
          ) : (
            <a className={styles.item} href="/user/sign-in">
              {t('sign-in')}
            </a>
          )}
        </div>
        <div className={styles.row}>
          <div className={styles.title}>{t('about-us')}</div>
          <a className={styles.item} href="/">
            {t('home')}
          </a>
          <a className={styles.item} href="/schedule">
            {t('schedule')}
          </a>
          <a className={styles.item} href="/pricing">
            {t('pricing')}
          </a>
        </div>
        <div className={styles.row}>
          <div className={styles.title}>{t('help')}</div>
          <a className={styles.item} href="/terms-of-use">
            {t('terms-of-use')}
          </a>
          <a className={styles.item} href="/privacy-policy">
            {t('privacy-policy')}
          </a>
          <a className={styles.item} href="mailto:movingstudiotaipei@gmail.com">
            {t('contact-us')}
          </a>
        </div>
        <div className={styles.row}>
          <div className={styles.title}>{t('follow-us')}</div>
          <div className={styles.item}>
            <a href="https://www.instagram.com/moving___studio/" target="_blank">
              <Icons.Instagram className={styles.icon} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
